import { TenantEntity } from '../TenantEntity'

export class AssemblyPlan extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
    this.className = 'AssemblyPlan'
  }

  // 航线产品uuid
  get airlineProductUuid() {
    return this._data.airlineProductUuid
  }

  set airlineProductUuid(airlineProductUuid) {
    this._data.airlineProductUuid = airlineProductUuid
  }

  get status() {
    return this._data.status
  }

  set status(status) {
    this._data.status = status || 1
  }

  get serviceProduct() {
    return this._data.serviceProduct
  }
  set serviceProduct(serviceProduct) {
    this._data.serviceProduct = serviceProduct
  }

  get carrierId() {
    return this._data.carrierId
  }
  set carrierId(carrierId) {
    this._data.carrierId = carrierId || 0
  }

  // Getter and Setter for basicWeight
  get basicWeight() {
    return this._data.basicWeight
  }
  set basicWeight(basicWeight) {
    this._data.basicWeight = basicWeight || 0.0
  }

  // Getter and Setter for limitWeight
  get limitWeight() {
    return this._data.limitWeight
  }
  set limitWeight(limitWeight) {
    this._data.limitWeight = limitWeight || 0.0
  }

  // Getter and Setter for availableCabinSpace
  get availableCabinSpace() {
    return this._data.availableCabinSpace
  }
  set availableCabinSpace(availableCabinSpace) {
    this._data.availableCabinSpace = availableCabinSpace || 0.0
  }

  // Getter and Setter for theoryVolume
  get theoryVolume() {
    return this._data.theoryVolume
  }
  set theoryVolume(theoryVolume) {
    this._data.theoryVolume = theoryVolume || 0.0
  }

  // Getter and Setter for sellableVolume
  get sellableVolume() {
    return this._data.sellableVolume
  }
  set sellableVolume(sellableVolume) {
    this._data.sellableVolume = sellableVolume || 0.0
  }

  get assemblyPlanNo() {
    return this._data.assemblyPlanNo
  }
  set assemblyPlanNo(assemblyPlanNo) {
    this._data.assemblyPlanNo = assemblyPlanNo
  }

  get sequenceNo() {
    return this._data.sequenceNo
  }
  set sequenceNo(sequenceNo) {
    this._data.sequenceNo = sequenceNo
  }

  // 航班号
  get flightNumber() {
    return this._data.flightNumber
  }

  set flightNumber(flightNumber) {
    this._data.flightNumber = flightNumber
  }

  // 航班日期
  get flightDate() {
    return this._data.flightDate
  }

  set flightDate(flightDate) {
    this._data.flightDate = flightDate
  }

  // 始发港
  get portOfDeparture() {
    return this._data.portOfDeparture
  }

  set portOfDeparture(portOfDeparture) {
    this._data.portOfDeparture = portOfDeparture
  }

  // 目的港
  get destinationPortCode() {
    return this._data.destinationPortCode
  }

  set destinationPortCode(destinationPortCode) {
    this._data.destinationPortCode = destinationPortCode
  }

  // 交货货站
  get cargoTerminalOperation() {
    return this._data.cargoTerminalOperation
  }

  set cargoTerminalOperation(cargoTerminalOperation) {
    this._data.cargoTerminalOperation = cargoTerminalOperation
  }

  // 出仓指令 0-不可出仓、1-可出仓
  get outboundInstruction() {
    return this._data.outboundInstruction
  }

  set outboundInstruction(outboundInstruction) {
    this._data.outboundInstruction = outboundInstruction
  }
}
